import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=5ede4b69&scoped=true"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=5ede4b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede4b69",
  null
  
)

export default component.exports